import React from 'react'
import './DeletepoupStyle.css'
import Button from '../../Button/Button'

const Deletepoup = ({ isActive, handleDelete, handleClose }) => {
    return (
        <div className={`popupWrapper poupviewtab  ${isActive && "active"}`}>
            <div className="popupContainer deleteIconpoup">
                <div className="popupBody mb-0">
                    <div className="datadelete">
                        <img src="/assets/img/gif/delete.gif" alt="" />
                        <h3>Are you sure you want to delete this data ?</h3>
                    </div>
                </div>
                <div className="popupHeader gap-10">
                    <Button name={'Discard'} className={'btnnormal'} onClick={handleClose} />
                    <Button name={'Delete'} className={'btnnormal active'} onClick={handleDelete} />
                </div>
            </div>
        </div>
    )
}

export default Deletepoup